import { useState } from 'react';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import I18n from 'I18n';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { usageTracker } from '../utils/usageTracker';
import { useIsMobile } from '../hooks/useBreakpoint';
import { jsx as _jsx } from "react/jsx-runtime";
export function TicketListingsSearch() {
  const {
    searchString,
    setSearchString
  } = useTicketListingsSortAndFilters();
  const [searchTerm, setSearchTerm] = useState(searchString);
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(SearchInput, {
    "data-test-id": "search-input",
    clearable: !isMobile,
    inlineSize: isMobile ? '100%' : '370px',
    marginInlineEnd: isMobile ? undefined : '400',
    placeholder: I18n.text('customer-portal-app.search.placeholder'),
    value: searchTerm,
    onChange: e => {
      if (e.target.value === '') {
        setSearchString('');
      }
      setSearchTerm(e.target.value);
    },
    onKeyDown: e => {
      if (e.key === 'Enter') {
        usageTracker.track('Customer Portal App', 'Tickets Discovered', {
          action: 'tickets-searched',
          screen: 'ticket-listings'
        });
        setSearchString(searchTerm);
      }
    }
  });
}